import React from "react";
import { Box, Button } from "@mui/material";
import { useTranslation } from "react-i18next";

const DocumentViewer = ({ pdf }) => {
  const { t } = useTranslation("account");
  return (
    <Box
      sx={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        bgcolor: "background.paper",
        overflowY: "scroll",
      }}
    >
      <iframe
        src={pdf}
        style={{ width: "100%", height: "90vh" }}
        title={t("common.pdfViewer")}
      />
      <Box sx={{ display: "flex", justifyContent: "center" }}>
        <Button
          variant="contained"
          onClick={() => window.close()}
          sx={{ margin: 2 }}
        >
          {t("common.back")}
        </Button>
      </Box>
    </Box>
  );
};

export default DocumentViewer;
